


document.addEventListener('DOMContentLoaded', function() {
// Apply or remove the .fr class based on the URL path and if the element has the 'lang' class
var pathname = window.location.pathname;
var langCode = pathname.split("/")[1];
var elements = document.getElementsByClassName('lang');

// Loop through the elements only once
for (var i = 0; i < elements.length; i++) {
  if (elements[i].classList.contains('lang')) { // Check if the element has the 'lang' class
    if (langCode === 'fr' || langCode === 'fr-fr') {
      elements[i].classList.add('fr');
    } else if (langCode === 'en-fr') {
          elements[i].classList.add('en');
      elements[i].classList.remove('fr');
    }
  }
}
  
  // Select all elements with the class 'scroll-to'
  var scrollToLinks = gsap.utils.toArray('.scroll-to');

  // Loop through each link and add a click event listener
  scrollToLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent the default link behavior

      // Get the target section's ID from the data attribute
      var target = link.getAttribute('data-target');
      var targetElement = document.querySelector(target);
    

      if (targetElement) {
        var targetPosition = targetElement.offsetTop - 100; // Offset by 100px
     
        // Use GSAP ScrollToPlugin to scroll to the target position
        gsap.to(window, {
          duration: 1, // Duration of the scroll animation in seconds
          scrollTo: targetPosition
        });
      }
    });
  });

  
});



